import { render, staticRenderFns } from "./TablesScreen.vue?vue&type=template&id=21db31cd&scoped=true&"
import script from "./TablesScreen.vue?vue&type=script&lang=js&"
export * from "./TablesScreen.vue?vue&type=script&lang=js&"
import style0 from "./TablesScreen.vue?vue&type=style&index=0&id=21db31cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21db31cd",
  null
  
)

export default component.exports